import React from 'react'
import { Icon, Tooltip, Text } from '@components/UI'

const Select = ({ active, onClick, dark, tooltip = {} }) => {
  return (
    <div
      className={`control-container ${active ? 'active' : ''} ${
        dark ? 'dark' : ''
      }`}
    >
      <button onClick={onClick}>
        <Icon name='select' />
      </button>
      <Tooltip
        content={
          <Text
            className='text-c semibold'
            style={{ lineHeight: 1, opacity: 0.5 }}
          >
            Select Tool
          </Text>
        }
        group={tooltip.top ? 'c2' : 'c7'}
        className='theme color-f background-a border info'
      />
    </div>
  )
}

export default Select
